"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformComponents = void 0;
const traverse_1 = __importDefault(require("traverse"));
const isBuilderElement = (item) => {
    var _a;
    return Boolean(((_a = item) === null || _a === void 0 ? void 0 : _a['@type']) === '@builder.io/sdk:Element');
};
function transformComponents(content, mappers) {
    return traverse_1.default(content).map(function (item) {
        var _a;
        if (isBuilderElement(item)) {
            if (item.component) {
                const mapper = mappers[item.component.name];
                if (mapper) {
                    this.update(Object.assign(Object.assign(Object.assign(Object.assign({}, item), (((_a = item.code) === null || _a === void 0 ? void 0 : _a.bindings) ? {
                        code: Object.assign(Object.assign({}, item.code), { bindings: Object.assign(Object.assign({}, item.code.bindings), Object.keys(mapper.props).reduce((acc, key) => {
                                const binding = item.code.bindings[`component.options.${mapper.props[key]}`];
                                if (binding) {
                                    return Object.assign(Object.assign({}, acc), { [key]: binding });
                                }
                                return acc;
                            }, {})) }),
                    }
                        : {})), (item.bindings
                        ? {
                            bindings: Object.assign(Object.assign({}, item.bindings), Object.keys(mapper.props).reduce((acc, key) => {
                                const binding = item.bindings[`component.options.${mapper.props[key]}`];
                                if (binding) {
                                    return Object.assign(Object.assign({}, acc), { [key]: binding });
                                }
                                return acc;
                            }, {})),
                        }
                        : {})), { component: Object.assign(Object.assign({}, item.component), { name: mapper.name, options: Object.keys(mapper.props).reduce((acc, key) => {
                                var _a;
                                return Object.assign(Object.assign({}, acc), { [key]: (_a = item.component) === null || _a === void 0 ? void 0 : _a.options[mapper.props[key]] });
                            }, {}) }) }));
                }
            }
        }
    });
}
exports.transformComponents = transformComponents;
